export default "__VITE_ASSET__DUGFAWOw__"